/*global define: false */

define('validateMaskedDate',['jquery', 'validate', 'unobtrusive'], function ($) {
    'use strict';

    $('.masked-date input:not(.masked-date-anchor)').on('keydown', function (e) {
        if (e.which === 13) {
            assemblyDate(this);
        }
    });

    $('.masked-date input:not(.masked-date-anchor)').on('blur', function () {
        assemblyDate(this);
    });

    function assemblyDate(elem) {
        var parent = $(elem).parent(),
            children = parent.children(),
            anchor = children[0],
            month = children[1],
            day = children[2],
            year = children[3];

        if (month.value && day.value && year.value) {
            anchor.value = month.value + '/' + day.value + '/' + year.value;
            $(anchor).valid();
        }
    }
});
